import { CommunicationChannelEmailV1SubTypeEnum, CommunicationChannelPhoneV1SubTypeEnum } from 'target/user';
import { trimToUndefined } from 'utils/utils';
export const mapToModelUser = (profile) => {
    return {
        login: profile.username,
        name: {
            givenNames: mapToGivenNames(profile),
            familyName: trimToUndefined(profile.lastName),
            prefix: trimToUndefined(profile.prefix),
            suffix: trimToUndefined(profile.suffix)
        },
        locale: profile.locale,
        communicationMethods: mapToCommunicationChannels(profile)
    };
};
const mapToGivenNames = (profile) => {
    const givenNames = [];
    const firstName = profile.firstName || '';
    givenNames.push(firstName);
    const middleName = trimToUndefined(profile.middleName);
    if (middleName) {
        givenNames.push(middleName);
    }
    return givenNames;
};
const mapToCommunicationChannels = (profile) => {
    const communicationChannels = [];
    communicationChannels.push(mapToEmailCommunicationChannel(profile.email), mapToPhoneCommunicationChannel(profile));
    return communicationChannels;
};
const mapToEmailCommunicationChannel = (email) => ({
    subType: CommunicationChannelEmailV1SubTypeEnum.Email,
    email
});
const mapToPhoneCommunicationChannel = (profile) => {
    return {
        subType: CommunicationChannelPhoneV1SubTypeEnum.Phone,
        phone: {
            countryCode: {
                code: trimToUndefined(profile.countryCode)
            },
            areaCode: {
                code: trimToUndefined(profile.areaCode)
            },
            number: trimToUndefined(profile.phoneNumber)
        }
    };
};
